module.exports = __webpack_public_path__ + "img/state1.f266b1e8.png";